import request from '@/utils/request'

// 上传
export function commonUpload(data, uploadProgressCallback) {
  return request({
    url: '/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: data,
    onUploadProgress: uploadProgressCallback
  })
}